const pricingData = [
  {
    id: 1,
    title: "Basic Plan",
    price: "59",
    yoga: false,
    fashion: false,
    swimming: false,
  },
  {
    id: 2,
    title: "Standard Plan",
    price: "99",
    yoga: true,
    fashion: true,
    swimming: false,
    bestOffer: true,
  },
  {
    id: 3,
    title: "Premium Plan",
    price: "156",
    yoga: true,
    fashion: true,
    swimming: true,
  },
];

export default pricingData;
